import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const buyers = [{
  name: 'Martín',
  city: 'Pilar'
}, {
  name: 'Facundo',
  city: 'San Isidro'
}, {
  name: 'Agustina',
  city: 'Córdoba'
}, {
  name: 'Juan Cruz',
  city: 'Mendoza'
}, {
  name: 'Bautista',
  city: 'Tandil'
}, {
  name: 'Tomás',
  city: 'Rosario'
}, {
  name: 'Ignacio',
  city: 'Salta'
}, {
  name: 'Delfina',
  city: 'Buenos Aires'
}, {
  name: 'Marcos',
  city: 'Lobos'
}, {
  name: 'Gonzalo',
  city: 'Venado Tuerto'
}, {
  name: 'Santiago',
  city: 'Río Cuarto'
}, {
  name: 'Joaquín',
  city: 'Trenque Lauquen'
}, {
  name: 'Nicolás',
  city: 'Coronel Suárez'
}, {
  name: 'Mateo',
  city: 'Mar del Plata'
}, {
  name: 'Lucas',
  city: 'Santa Fe'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Hide after 4 seconds
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 5000);
    // Then random intervals between 8-12 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        setTimeout(showPopup, Math.random() * 4000 + 8000);
      }
    }, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-141">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-24 md:bottom-6 left-4 md:left-6 z-50 glass-card rounded-lg p-4 shadow-2xl border-polo-gold/30 max-w-[300px] flex items-start gap-3" data-id="element-142">
          <div className="bg-green-500/20 p-2 rounded-full shrink-0" data-id="element-143">
            <CheckCircle className="w-5 h-5 text-green-400" data-id="element-144" />
          </div>
          <div data-id="element-145">
            <p className="text-sm font-medium text-white" data-id="element-146">
              {currentBuyer.name} de {currentBuyer.city}
            </p>
            <p className="text-xs text-gray-300 mt-1" data-id="element-147">
              acaba de comprar Pack Polo 360
            </p>
            <p className="text-[10px] text-polo-gold mt-2 font-medium" data-id="element-148">
              Hace unos minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}